module.exports = __webpack_public_path__ + "img/ico-bed.109f4d51.svg";